import React from 'react';
import { CloudHeaderV2 } from '../common/HeaderV2';

export const DefaultLayout = ({ children }: { children: React.ReactNode }) => (
  <main>
    <CloudHeaderV2 />
    {children}
  </main>
);
